<template>
  <main class="min-h-screen bg-[#f7f5ef] text-stone-950">
    <section class="border-b border-stone-200 bg-white">
      <div class="mx-auto max-w-6xl px-5 py-14 md:px-8">
        <p class="text-xs font-black uppercase tracking-[0.22em] text-teal-700">ClearFlow homeowner guides</p>
        <h1 class="mt-4 max-w-4xl text-4xl font-black tracking-tight sm:text-6xl">Know what to ask before someone climbs onto your roof.</h1>
        <p class="mt-5 max-w-3xl text-lg leading-8 text-stone-700">
          Our guides answer practical gutter questions, explain how to compare service, and use local jobs to show what can happen on real properties. We name our sources and leave out what they cannot prove.
        </p>
      </div>
    </section>

    <section class="py-12">
      <div class="mx-auto grid max-w-6xl gap-8 px-5 md:px-8">
        <article v-for="post in blogPosts" :key="post.slug" class="overflow-hidden rounded-2xl border border-stone-300 bg-white shadow-sm md:grid md:grid-cols-[0.9fr_1.1fr]">
          <NuxtLink :to="`/blog/${post.slug}`" class="block min-h-64 bg-stone-200">
            <img :src="post.heroImage" :alt="post.heroAlt" class="h-full w-full object-cover" />
          </NuxtLink>
          <div class="p-6 sm:p-8">
            <p class="text-xs font-black uppercase tracking-[0.18em] text-teal-700">{{ post.eyebrow }}</p>
            <h2 class="mt-3 text-3xl font-black leading-tight tracking-tight">
              <NuxtLink :to="`/blog/${post.slug}`" class="hover:text-teal-800">{{ post.title }}</NuxtLink>
            </h2>
            <p class="mt-4 leading-7 text-stone-700">{{ post.description }}</p>
            <div class="mt-5 flex flex-wrap gap-3 text-xs font-bold text-stone-500">
              <span>{{ formatDate(post.publishedAt) }}</span><span>·</span><span>{{ post.readingMinutes }} min read</span><span>·</span><span>{{ post.city }}</span>
            </div>
            <NuxtLink :to="`/blog/${post.slug}`" class="mt-6 inline-flex rounded-md bg-stone-950 px-5 py-3 text-sm font-black uppercase tracking-wide text-white hover:bg-stone-800">Read the article</NuxtLink>
          </div>
        </article>
      </div>
    </section>
  </main>
</template>

<script setup lang="ts">
import { blogPosts } from "~~/data/blogPosts";

function formatDate(date: string) {
  return new Intl.DateTimeFormat("en-US", { month: "long", day: "numeric", year: "numeric" }).format(new Date(`${date}T12:00:00`));
}

useHead({
  title: "Gutter Cleaning Stories & Homeowner Answers | ClearFlow Blog",
  meta: [{ name: "description", content: "Local gutter cleaning case studies that explain common problems, successful service outcomes, and what homeowners should ask before hiring." }],
});
</script>
